import { render, staticRenderFns } from "./DocumentFileUploader.vue?vue&type=template&id=82c75cde&scoped=true&"
import script from "./DocumentFileUploader.vue?vue&type=script&lang=js&"
export * from "./DocumentFileUploader.vue?vue&type=script&lang=js&"
import style0 from "./DocumentFileUploader.vue?vue&type=style&index=0&id=82c75cde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c75cde",
  null
  
)

export default component.exports